//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useCallback, useContext, useEffect } from "react";

// custom pages
import { styles } from "./styles";
import CostCenter from "./CostCenter";
import RollForward from "./RollForward";
import Burn from "./Burn";
import Earn from "./Earn";
import PointsBalance from "./PointsBalance";
import MemberIDStatus from "./MemberIDStatus";
import CustomerStatus from "./CustomerStatus";
import ShiptoSummary from "./ShiptoSummary";
import MemberLevelReward from "./MemberLevelReward";
import MemberRewardsActivity from "./MemberRewardsActivity";
import Context from "context/context";

import DeactivationSummary from "./DeactivationSummary";
import YetToBeDeactivation from "./YetToBeDeactivation";
import PromoReport from "./PromoReport";
import SignatureAudit from "./SignatureAudit";
import StartupAudit from "./StartupAuditReport";


// material-ui
import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";

import { useTranslation } from 'react-i18next';
import Ciprian from "./Ciprian";
import SignatureStatement from "./SignatureStatement";
import FSCSummaryReport from "./FSCSummaryReport";
import WeeklyConsentReport from "./WeeklyConsentReport";
import WelcomeEmailReport from "./WelcomeEmailReport";
import MarketoMailchimpReport from "./MarketoMailchimpReport"
import PointExpirationMonthly from "./PointsExpirationMontlhly"
import PBIReport from "./PBIReport";
import SignatureBenefitStatement from "./SignatureBenefitStatement";
import DormantRemainderMailTracker from "./DormantReaminderMailTracker";
import ThriveReport from "./ThriveReport";
import StartupBenefitStatement from "./StartupBenefitStatement";
import UnlockEarnReport from "./UnlockEarnReport";
import ChurnSignature from "./churnSignature";
import UnlockTrend from "./unlockTrendAnalysis";
import UnlockOriginReport from "./UnlockOriginReport";
import UnlockShiptoEarnReport from "./UnlockShiptoEarnReport";
import GrowthBonusMailReport from "./GrowthBonusMailReport"
import UnlockMilestoneTracker from "./UnlockMilestoneTracker"
import SignatureMilestoneTracker from "./SignatureMilestoneTracker"













const GlobalCss = withStyles({
  "@global": {
    ".MuiFormLabel-root": {
      color: "black",
    },
  },
})(() => null);

const formLabelsTheme = createMuiTheme({
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: "#db3131",
        "&$error": {
          color: "#db3131",
        },
      },
    },
  },
  palette: {
    primary: {
      main: "#000000",
    },
  },
});

export default function Report(props) {
  const { state, dispatch } = useContext(Context);
  const classes = styles();
  const { t , i18n} = useTranslation()
  const [disableDropdown, setDisableDropdown] = useState(false);
  const [states, setstates] = useState({
    currentReport: "",
  });
  const org = state?.userInfo?.loyalty_organization_name;

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "Reports"],
    });
  }, []);
  const reports =  org == "Henry Schein Dental" ? [
    {
      reportName: "Roll Forward",
      id: 0,
    },
    {
      reportName: "Earn",
      id: 1
    },
    {
      reportName: "Redemption",
      id: 2
    },
    {
      reportName: "Points Balance",
      id: 3
    },
    {
      reportName: "Enrollment Statistics at Shipto",
      id: 4
    },
    {
      reportName: "Daily Enrollment Summary",
      id: 5
    },
    {
      reportName: "Daily Shipto Enrollment Summary",
      id: 6
    },
    {
      reportName: "Member Level Reward Activity",
      id: 7
    },
    {
      reportName: "Member Rewards Activity - Summary Level",
      id: 8
    },
    {
      reportName: "Finance & Accounting - Summary",
      id: 9
    },
    // {
    //   reportName: "Finance & Accounting - Tier Movement",
    //   id: 10
    // },
    {
      reportName: "Finance & Accounting - Sales Category",
      id: 11
    },
    {
      reportName: "Finance & Accounting - 24 Month Expiration",
      id: 12
    },
    {
      reportName: "Finance & Accounting - Unconsented",
      id: 13
    },
    {
      reportName: "Deactivated Accounts",
      id: 14
    },
    {
      reportName: "Scheduled Deactivation Accounts",
      id: 15,
    } ,
    {
      reportName: "Promotion Earn Report",
      id: 16,
    } ,
    // {
    //   reportName: "Signature Statement",
    //   id: 17,
    // },

    {
      reportName: "FSC Summary Report",
      id: 18,
    },

    {
      reportName: "Welcome Email Report",
      id: 19,
    },

    {
      reportName: "TR Statement Target List - Consented",
      id: 20,
    },
    {
      reportName: "TR Statement Target List - Unconsented",
      id: 24,
    },

    {
      reportName: "Point Expiration Monthly",
      id: 21,
    }
    ,

    {
      reportName: "Thrive Dormancy Members Report",
      id: 22,
    },
    {
      reportName: "Signature Benefit Statement",
      id: 23,
    },
    {
      reportName: "Signature Audit Report",
      id: 27,
    },
    {
      reportName: "Dormant Campaign Report",
      id: 28,
    },

    {
      reportName: "Thrive Rewards Report",
      id: 29,
    },
    {
      reportName: "StartUp Audit Report",
      id: 30,
    },
    // {
    //   reportName: "StartUp Benefit Report",
    //   id: 31,
    // },

    {
      reportName: "Unlock Earn Report",
      id: 31,
    },

    {
      reportName: "Thrive Signature Net Subscriber Report",
      id: 32,
    },

    {
      reportName: "Thrive Unlocked Trend Analysis Report",
      id: 33,
    },

    
    {
      reportName: "Unlocked Origin Tracking Report",
      id: 34,
    },

    {
      reportName: "Unlocked Ship-to Earn Report",
      id: 35,
    },

    {
      reportName: "Growth Bonus Mail Tracker Report",
      id: 36,
    },

    {
      reportName: "Unlock Milestone Tracker",
      id: 37,
    },

    {
      reportName: "Signature Milestone Tracker",
      id: 38,
    },



  ]:[
    {
      reportName: "Roll Forward",
      id: 0,
    },
    {
      reportName: "Earn",
      id: 1
    },
    {
      reportName: "Redemption",
      id: 2
    },
    {
      reportName: "Points Balance",
      id: 3
    },
    {
      reportName: "Enrollment Statistics at Shipto",
      id: 4
    },
    {
      reportName: "Daily Enrollment Summary",
      id: 5
    },
    {
      reportName: "Daily Shipto Enrollment Summary",
      id: 6
    },
    {
      reportName: "Member Level Reward Activity",
      id: 7
    },
    {
      reportName: "Member Rewards Activity - Summary Level",
      id: 8
    },

    {
      reportName: "Mailchimp Report",
      id: 25,
    },
   

    state?.userInfo?.loyalty_organization_name === "Henry Schein Canada" ? {
      reportName: "Point Expiration Monthly",
      id: 21
    }:"",

    state?.userInfo?.loyalty_organization_name === "Henry Schein Canada" ? {
      reportName: "Consent Report",
      id: 26
    }:""
  ];

  // report tab switch case
  function setReport(tab) {
    switch (tab) {
      case 0:
        return (
          <RollForward
            page={"Roll Forward"}
            setDisableDropdown={setDisableDropdown}
          />
        );
      case 1:
        return <Earn page={"Earn"} setDisableDropdown={setDisableDropdown} />;
      case 2:
        return (
          <Burn page={"Redemption"} setDisableDropdown={setDisableDropdown} />
        );
      case 3:
        return (
          <PointsBalance
            page={"Points Balance"}
            setDisableDropdown={setDisableDropdown}
          />
        );
      case 4:
        return (
          <MemberIDStatus
            page={"Enrollment Statistics at Shipto"}
            setDisableDropdown={setDisableDropdown}
          />
        );
      case 5:
        return (
          <CustomerStatus
            page={"Daily Enrollment Summary"}
            setDisableDropdown={setDisableDropdown}
          />
        );
      case 6:
        return (
          <ShiptoSummary
            page={"Daily Shipto Enrollment Summary"}
            setDisableDropdown={setDisableDropdown}
          />
        );
      case 7:
        return (
          <MemberLevelReward
            page={"Member Level Reward Activity"}
            setDisableDropdown={setDisableDropdown}
          />
        );
      case 8:
        return (
          <MemberRewardsActivity
            page={"Member Rewards Activity - Summary Level"}
            setDisableDropdown={setDisableDropdown}
          />
        );
      case 9:
        return (
          <Ciprian
            page={"Finance & Accounting - Summary"}
            setDisableDropdown={setDisableDropdown}
            ReportID={1}
          />
        );
      case 10:
        return (
          <Ciprian
            page={"Finance & Accounting - Tier Movement"}
            setDisableDropdown={setDisableDropdown}
            ReportID={2}
          />
        );
      case 11:
        return (
          <Ciprian
            page={"Finance & Accounting - Sales Category"}
            setDisableDropdown={setDisableDropdown}
            ReportID={3}
          />
        );
      case 12:
        return (
          <Ciprian
            page={"Finance & Accounting - 24 Month Expiration"}
            setDisableDropdown={setDisableDropdown}
            ReportID={4}
          />
        );
      case 13:
        return (
          <Ciprian
            page={"Finance & Accounting - Unconsented"}
            setDisableDropdown={setDisableDropdown}
            ReportID={5}
          />
        );
      case 14:
        return (
          <DeactivationSummary
            page={"DeactivatedAccounts"}
            setDisableDropdown={setDisableDropdown}
          />
        );
      case 15:
        return (
          <YetToBeDeactivation
            page={"ScheduledDeactivationAccounts"}
            setDisableDropdown={setDisableDropdown}
          />
        );
        case 16:
          return (
            <PromoReport
              page={"PromoReport"}
              setDisableDropdown={setDisableDropdown}
            />
          );
          case 17:
          return (
            <SignatureStatement
              page={"Signature Statement"}
              setDisableDropdown={setDisableDropdown}
            />
          );

          case 18:
            return (
              <FSCSummaryReport
                page={"FSC Summary Report"}
                setDisableDropdown={setDisableDropdown}
              />
            );

            case 19:
            return (
              <WelcomeEmailReport
                page={"Welcome Email Report"}
                setDisableDropdown={setDisableDropdown}
              />
            );

            case 20:
              return (
                <MarketoMailchimpReport
                  page={"TR Statement Target List - Consented"}
                  setDisableDropdown={setDisableDropdown}
                />
              );

              case 21:
              return (
                <PointExpirationMonthly
                  page={"Point Expiration Monthly"}
                  setDisableDropdown={setDisableDropdown}
                />
              );
              case 22:
              return (
                <PBIReport
                  page={"Thrive Dormancy Members Report"}
                  setDisableDropdown={setDisableDropdown}
                />
              );
              case 23:
                return (
                  <SignatureBenefitStatement
                    page={"Signature Benefit Statement"}
                    setDisableDropdown={setDisableDropdown}
                  />
                );
                case 24:
                  return (
                    <MarketoMailchimpReport
                      page={"TR Statement Target List - Unconsented"}
                      setDisableDropdown={setDisableDropdown}
                    />
                  );
                  case 25:
                  return (
                    <MarketoMailchimpReport
                      page={"MailChimpReport"}
                      setDisableDropdown={setDisableDropdown}
                    />
                  );

                  case 26:
                    return (
                      <WeeklyConsentReport
                        page={"WeeklyConsentReport"}
                        setDisableDropdown={setDisableDropdown}
                      />
                    );
                    case 27:
                      return (
                        <SignatureAudit
                          page={"SignatureAudit"}
                          setDisableDropdown={setDisableDropdown}
                        />
                      );
                      case 28:
                        return (
                          <DormantRemainderMailTracker
                            page={"DormantRemainderMailTracker"}
                            setDisableDropdown={setDisableDropdown}
                          />
                        );

                        case 29:
                          return (
                            <ThriveReport
                              page={"ThriveReport"}
                              setDisableDropdown={setDisableDropdown}
                            />
                          );
                          case 30:
                            return (
                              <StartupAudit
                                page={"StartupAudit"}
                                setDisableDropdown={setDisableDropdown}
                              />
                            );
                            case 31:
                            return (
                              <UnlockEarnReport
                                page={"UnlockEarnReport"}
                                setDisableDropdown={setDisableDropdown}
                              />
                            );
                            // case 31:
                            // return (
                            //   <StartupBenefitStatement
                            //     page={"StartupBenefitStatement"}
                            //     setDisableDropdown={setDisableDropdown}
                            //   />
                            // );
                            case 32:
                              return (
                                <ChurnSignature
                                  page={"ChurnSignature"}
                                  setDisableDropdown={setDisableDropdown}
                                />
                              );
                            case 33:
                            return (
                              <UnlockTrend
                                page={"UnlockTrend"}
                                setDisableDropdown={setDisableDropdown}
                              />
                            );
                            case 34:
                            return (
                              <UnlockOriginReport
                                page={"UnlockOriginReport"}
                                setDisableDropdown={setDisableDropdown}
                              />
                            );
                            case 35:
                            return (
                              <UnlockShiptoEarnReport
                                page={"UnlockShiptoEarnReport"}
                                setDisableDropdown={setDisableDropdown}
                              />
                            );
                            case 36:
                            return (
                              <GrowthBonusMailReport
                                page={"GrowthBonusMailReport"}
                                setDisableDropdown={setDisableDropdown}
                              />
                            );

                             case 37:
                            return (
                              <UnlockMilestoneTracker
                                page={"UnlockMilestoneTracker"}
                                setDisableDropdown={setDisableDropdown}
                              />
                            );

                             case 38:
                            return (
                              <SignatureMilestoneTracker
                                page={"SignatureMilestoneTracker"}
                                setDisableDropdown={setDisableDropdown}
                              />
                            );
                           
                           
                         
    }
  }

  return (
    <React.Fragment>
      <GlobalCss />
      <Grid container className={classes.root}>
        <Grid item xs={12} sm={12} lg={12} className={classes.topGrid}>
          <ThemeProvider theme={formLabelsTheme}>
            <TextField
              id={"report"}
              label={t("Select Report Type")}
              select
              required
              type={"text"}
              className={classes.input}
              value={states.currentReport}
              onChange={(e) => {
                setStates({
                  currentReport: e.target.value,
                });
              }}
              disabled={disableDropdown}
            >
              {reports.map((r, i) => (
                <MenuItem value={r.id} key={t(r.reportName)}>
                  {t(r.reportName)}
                </MenuItem>
              ))}
            </TextField>
          </ThemeProvider>
        </Grid>
      </Grid>
      <div>{setReport(states.currentReport)}</div>
    </React.Fragment>
  );
}
